<template>
  <div :class="{ 'with-subject': !!subject, 'with-body': !!body }" @dblclick="startEditing">
    <div v-if="subject" class="subject" dir="auto">{{ subject }}</div>
    <div v-if="body" ref="body" class="body" dir="auto" v-html="body" />
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapGetters } from 'vuex'
import { mathifyElement } from 'bits/math'
import { link } from 'bits/autolinker'
import { $ } from 'bits/jquery'
export default {
  props: ['post', 'isEditableByCurrentUser'],
  computed: {
    ...mapGetters(['isBackchannel']),
    headline() {
      return this.post.headline
    },
    subject() {
      return this.post.subject
    },
    rawBody() {
      return this.post.body
    },
    body() {
      return this.autoLink(this.rawBody)
    },
  },
  updated() {
    this.$nextTick(() => {
      this.performPostUpdateActions()
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.performPostUpdateActions()
    })
  },
  methods: {
    startEditing() {
      if (this.isEditableByCurrentUser && !this.isBackchannel) {
        this.$emit('edit')
      }
    },
    autoLink(text) {
      const linkedText = link(text, {
        replaceFn: match => {
          var tag = match.buildTag()
          tag.setAttr('rel', 'noopener nofollow')
          tag.setAttr('data-bridged-link', 'external')
          return tag
        },
      })
      return linkedText
    },
    performPostUpdateActions() {
      $('var', this.$el).each((index, el) => {
        if (!el.children[0] || el.children[0].className !== 'katex') {
          mathifyElement(el)
        }
      })
      const bridgedLinkAttr = { 'data-bridged-link': 'external' }
      $('a[href^=h]', this.$el).attr({ target: '_blank', rel: 'noopener nofollow', ...bridgedLinkAttr })
    },
  },
}
</script>

<style lang="scss">
@import './../../assets/stylesheets/3/modules/all';

.wish {
  .words {
    var {
      font-family: monospace;
      display: block;
      text-align: center;
    }

    //OLD
    padding: 4px 8px;

    .subject {
      position: relative;
      font-weight: 400;
      word-wrap: break-word;
      white-space: pre-wrap;
      font-size: 15px;
      line-height: 1.4em;
      touch-action: manipulation;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .body {
      //@include transition(color 0.25s linear);
      position: relative;
      display: block;
      word-wrap: break-word;
      white-space: pre-wrap;
      touch-action: manipulation;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    pre {
      white-space: pre-wrap;
      font-family: $mono-font-family;
      padding: 0.5em;
      background-color: rgba(black, 0.04);
      margin-left: -0.5em;
      margin-right: -0.5em;
      border-radius: $default-border-radius;
    }

    ol {
      list-style-type: decimal;
    }

    ul {
      list-style-type: disc;
    }

    ul,
    ol {
      list-style-position: outside;
      padding-left: 2em;

      li {
        margin: 0.25em 0;
      }
    }

    blockquote {
      font-style: italic;
      padding: 0 1em;
      border-left-width: 0.25em;
      border-left-style: solid;
      border-left-color: var(--muted-text-color);
    }

    mark {
      background-color: $material-light-green-accent-100;
      color: inherit;
    }
  }

  section.footer {
    padding: 8px;
    color: #dddddd;
    line-height: 16px;
    font-size: 12px;
    min-height: 16px;
  }

  &[data-view-mode='edit'] {
    .created-at {
      display: none;
    }
    .word-count {
      display: show;
    }

    .firefox & .subject.empty[contenteditable]:before {
      position: relative;
    }
    section.words .empty {
      color: rgba(black, 25);
    }
  }
}
</style>
